export const COLLECTION_HEADING_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  CUSTOM_IMG_OR_BANNER: 'custom_img',
};

export const COLLECTIONS_ROUTE_STYLING = {
  caligraphyCollection: {
    heading_type: COLLECTION_HEADING_TYPES.TEXT,
    text_size_desktop: 'extraLarge',
    text_size_mobile: 'large',
    text_thickness: 'medium',
    text_case: 'none',
    text_color: '#000000',
    text_placement: 'on-image',
    text_alignment: 'left',
    overlay: 30,
    height: '360px',
    image_height: 'small',
    height_type: 'pre', // "custom"
    // These names are kept same as that are used in carousel
    isBannerFullWidth: true,
    images: [], // {image_url: "", src: "", is_video:"", actions: {handler: "", type: "", newTab: ""}}
  },
  caligraphyCategory: {
    heading_type: COLLECTION_HEADING_TYPES.TEXT,
    text_size_desktop: 'extraLarge',
    text_size_mobile: 'large',
    text_thickness: 'medium',
    text_case: 'none',
    overlay: 30,
    text_color: '#000000',
    text_placement: 'on-image',
    text_alignment: 'left',
    height: '360px',
    image_height: 'small',
    // These names are kept same as that are used in carousel
    isBannerFullWidth: true,
    images: [], // {image_url: "", src: "", is_video:"", actions: {handler: "", type: "", newTab: ""}}
  },
  sortAndFilter: {
    layout_desktop: 'layout0',
    layout_mobile: 'layout1',
    title_case: 'none',
    filter_options_case: 'none',
    title_color: '#111C36',
    filter_options_color: '#111C36',
    title_thickness: 'regular',
    filter_options_thickness: 'medium',
    desktop_configs: {
      title_size: 'medium',
      filter_options_size: 'medium',
    },
    mobile_configs: {
      title_size: 'medium',
      filter_options_size: 'medium',
    },
    keep_filters_open: true,
    appearances: {
      color: 'layout1',
      size: 'layout1',
    },
  },
  gridAndPagination: {
    num_columns_desktop: 4,
    num_columns_mobile: 2,
    num_products_desktop: 24,
    num_products_mobile: 24,
    pagination_style_desktop: 'add-pagination',
    pagination_style_mobile: 'add-pagination',
    pagination_appearance: 'layout1',
  },
  categoryCollectionData: {
    listPresentation: {
      contentItems: { listItem: [], type: 'PLP' },
    }

  }
};
